"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var response_model_1 = require("../model/response.model");
var validatrion_message_model_1 = require("../model/validatrion-message.model");
/**
 * @author gevorg.avetisyan on 4/21/2017.
 */
var ChangedDataResponseSerializer = /** @class */ (function () {
    function ChangedDataResponseSerializer() {
    }
    ChangedDataResponseSerializer.Serializer = function (json) {
        var response;
        if (json["success"]) {
            response = new response_model_1.ResponseChangedData(true, null, json["status"]);
        }
        else {
            var listErrors = [];
            if (json["validationMessages"]) {
                for (var _i = 0, _a = json["validationMessages"]; _i < _a.length; _i++) {
                    var jsonVal = _a[_i];
                    var validationMessage = new validatrion_message_model_1.ValidationMessage(jsonVal.severity, jsonVal.keys, new idm_crosscutting_concepts_frontend_1.MultilingualString(ChangedDataResponseSerializer.getMultilingualMap(jsonVal.message)));
                    listErrors.push(validationMessage);
                }
            }
            response = new response_model_1.ResponseChangedData(false, listErrors);
        }
        return response;
    };
    ChangedDataResponseSerializer.getMultilingualMap = function (json) {
        var map = new Map();
        for (var k in json) {
            map.set(Number(k), json[k]);
        }
        return map;
    };
    return ChangedDataResponseSerializer;
}());
exports.ChangedDataResponseSerializer = ChangedDataResponseSerializer;
//# sourceMappingURL=changet-data-response.serializer.js.map